import React from "react";
import { useHistory } from "react-router-dom";


interface headerProps {
    setClear?: React.Dispatch<React.SetStateAction<boolean>>,
    setAnswerValue?: React.Dispatch<React.SetStateAction<number>>,
    answerValue?: number
    commitAnswer: () => void,
    goForward: boolean,
    type: string,

    open?: () => void,
    start?: () => void,
    stop?: () => void,
    recordAgain?: () => void,
    setFileAvailable?: React.Dispatch<React.SetStateAction<boolean>>,
    buttonState?: string,

    isInstruction?: boolean,
    showInstruction?: () => void,
    gameButtons?: JSX.Element
}

function Header(props: headerProps): JSX.Element {
    const [forwardButton, setForwardButton] = React.useState(<></>);
    const [wantToGoHome, setGoingHome] = React.useState(false);
    const history = useHistory();

    React.useEffect(() => {
        if (wantToGoHome) {
            let letsGo = window.confirm("Haluatko palata takaisin? Tehtäviä ei tallenneta.");
            if (letsGo) {
                history.push('/student')
            } else setGoingHome(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wantToGoHome]);

    let itemButtons = <></>;

    const size = " h-14 w-14 md:h-14 md:w-14 lg:h-20 lg:w-20 xl:h-24 xl:w-24 2xl:h-24 2xl:w-24 4xl:h-28 4xl:w-28 6xl:h-32 6xl:w-32 7xl:h-36 7xl:w-36 10xl:h-44 10xl:w-44 block ";
    const ringSize = " ring-4 xl:ring-8 ring-inset rounded-lg xl:rounded-2xl 6xl:rounded-3xl ";
    const symbolSize = " text-3xl lg:text-5xl 2xl:text-6xl 5xl:text-7xl 7xl:text-8xl font-bold ";
    let rightColSpan = " col-span-2 ";
    let centerColSpan = " col-span-7 "

    let clearAll = (
        <div className="">
            <button className={size + symbolSize + ringSize + "  bg-transparent ring-red-500 hover:bg-red-200 text-red-500 "} type="button" onClick={() => { props.setClear ? props.setClear(true) : emptyFunction() }}>
                <span className="ri-delete-bin-line "></span>
            </button>
        </div>);

    let homeButton = (
        <div className="">
            <button className={size + symbolSize + ringSize + " bg-transparent ring-teal-500 hover:bg-teal-200 text-teal-500" + symbolSize} type="button" onClick={() => { setGoingHome(true) }}>
                <span className="ri-home-2-line "></span>
            </button>
        </div>

    );

    function emptyFunction() {
        return;
    }

    function findErrorClick(value: boolean) {
        let answerValue = value ? 1 : 0;

        if (props.setAnswerValue !== undefined) {
            if (answerValue === props.answerValue) { props.setAnswerValue(-1) }
            else { props.setAnswerValue(answerValue); }
        }
    }

    React.useEffect(() => {
        if (props.goForward) {
            const forwardOkButton = (
                <div className="">
                    <button className={size + ringSize + symbolSize + " ring-teal-500 hover:bg-teal-200 text-teal-500 hover:text-teal-400"} type="button" onClick={() => props.commitAnswer()}>
                        <span className={"ri-arrow-right-s-line "}></span>
                    </button>
                </div>
            );

            setForwardButton(forwardOkButton);

        } else {
            const forwardDisabledButton = (
                <div className={"pointer-events-none"}>
                    <button className={size + ringSize + symbolSize + " ring-gray-500 text-gray-500 bg-gray-200 pointer-events-none"} type="button">
                        <span className={"ri-arrow-right-s-line "}></span>
                    </button>
                </div >
            );

            setForwardButton(forwardDisabledButton);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.goForward])


    switch (props.type) {
        case "videoInstruction":
        case "oneChoice": {
            clearAll = <></>;
            break;
        }
        case "findError": {
            let green = props.answerValue === 1 ? " ring-green-700 hover:bg-green-400 bg-green-500 text-green-700 " : " ring-green-500 hover:bg-green-400 bg-green-200 text-green-600 ";
            let red = props.answerValue === 0 ? " ring-red-700 hover:bg-red-400 bg-red-500 text-red-700 " : " ring-red-500 hover:bg-red-400 bg-red-200 text-red-600 ";

            clearAll = <></>;
            rightColSpan = "col-span-1";
            centerColSpan = "col-span-8"

            itemButtons = (
                <div className="flex gap-2 ">
                    <div>
                        <button className={size + symbolSize + ringSize + green} type="button" onClick={() => findErrorClick(true)}>
                            <span className="ri-check-fill"></span>
                        </button>
                    </div>
                    <div>
                        <button className={size + symbolSize + ringSize + red} type="button" onClick={() => findErrorClick(false)}>
                            <span className="ri-close-fill"></span>
                        </button>
                    </div>
                </div>
            );

            break;
        }
        case "videoRecording": {
            itemButtons = (
                <RecorderButtons
                    open={props.open ? props.open : emptyFunction}
                    start={props.start ? props.start : emptyFunction}
                    stop={props.stop ? props.stop : emptyFunction}
                    recordAgain={props.recordAgain ? props.recordAgain : emptyFunction}
                    setFileAvailable={props.setFileAvailable ? props.setFileAvailable : emptyFunction}
                    buttonState={props.buttonState ? props.buttonState : ""}
                    size={size}
                    symbolSize={symbolSize}
                    ringSize={ringSize}
                />);

            break;
        }
        case "memoryGame": {
            let instructionHidden = props.isInstruction ? "" : " hidden";

            let instructionButton = (
                <div className="">
                    <button className={size + ringSize + symbolSize + " bg-transparent ring-teal-500 hover:bg-teal-200 text-teal-500 hover:text-teal-400 " + instructionHidden} type="button" onClick={props.showInstruction}>
                        <span className={"ri-question-mark"}></span>
                    </button>
                </div>
            );

            itemButtons = props.gameButtons ? props.gameButtons : <></>;
            clearAll = <></>;

            return (
                <div className="border-t-2 2xl:border-t-4 9xl:border-t-8 border-teal-500 pt-2 mt-2 md:mt-3 lg:mt-5 lg:pt-3 2xl:mt-6 2xl:pt-4 8xl:mt-7 8xl:pt-5 11xl:mt-8 11xl:pt-6">
                    <div className="mr-2 ml-2 grid grid-cols-10 ">
                        <div className={"flex xl:ml-5 7xl:ml-10 col-span-2 gap-x-2 4xl:gap-x-4 10xl:gap-x-8 "}>
                            {homeButton}
                            {instructionButton}
                        </div>
                        <div className="col-span-7 xl:col-span-6 flex justify-center text-center gap-x-2 4xl:gap-x-4 10xl:gap-x-8">
                            {itemButtons}
                        </div>
                        <div className="xl:mr-5 7xl:mr-10 justify-end text-left float-left col-span-1 xl:col-span-2 flex gap-x-2 4xl:gap-x-4 10xl:gap-x-8 ">
                            {forwardButton}
                        </div>
                    </div>
                </div>
            );
        }
        default: break;
    }

    return (
        <div className="pb-3 mb-3">
            <div className="mr-2 ml-2 grid grid-cols-10 pt-1 mt-1 ">
                <div className={"ml-2 flex float-left text-left justify-start col-span-1 gap-x-2 4xl:gap-x-4 10xl:gap-x-8 "}>
                    {homeButton}
                </div>
                <div className={" flex justify-center text-center gap-x-2 4xl:gap-x-4 10xl:gap-x-8 " + centerColSpan}>
                    {itemButtons}
                </div>
                <div className={" mr-2 float-right text-right justify-end flex gap-x-2 4xl:gap-x-4 10xl:gap-x-8 " + rightColSpan}>
                    {clearAll}
                    {forwardButton}
                </div>
            </div>
        </div>
    );
}


export interface recorderButtonsProps {
    open: () => void,
    start: () => void,
    stop: () => void,
    recordAgain: () => void,
    setFileAvailable: React.Dispatch<React.SetStateAction<boolean>>,
    buttonState: string,
    size: string,
    symbolSize: string
    ringSize: string
}

function RecorderButtons(props: recorderButtonsProps): JSX.Element {
    let textSize = " text-xs md:text-sm lg:text-xl 4xl:text-2xl 7xl:text-3xl 10xl:text-5xl ";
    let disabledRing = " disabled cursor-not-allowed opacity-50 ring-gray-500"
    let disabledText = " text-gray-500 disabled cursor-not-allowed"

    let recorderButton: JSX.Element = (
        <button className={props.size + props.ringSize + " ring-red-500"} type="button" onClick={props.start}>
            <div className={props.symbolSize + " hover:text-red-400 text-red-600 ri-record-circle-fill"}></div>
            <div className={textSize + " hover:text-gray-600 text-gray-800"}>Nauhoita</div>
        </button>);

    let watchVideoButton: JSX.Element = (
        <button className={props.size + props.ringSize + disabledRing} type="button">
            <div className={props.symbolSize + disabledText + " ri-play-fill"}></div>
            <div className={textSize + " hover:text-gray-600 text-gray-800"}>Katso</div>
        </button>
    );

    switch (props.buttonState) {
        case "closed": {
            recorderButton = (
                <button className={props.size + props.ringSize + " ring-gray-500 hover:bg-gray-200 hover:text-gray-600 text-gray-800"} type="button" onClick={props.open}>
                    <div className={props.symbolSize + " hover:text-gray-600 text-gray-800 ri-camera-off-fill"}></div>
                    <div className={textSize}>Avaa</div>
                </button>
            );
            break;

        }
        case "recording": {
            recorderButton = (
                <button className={props.size + props.ringSize + " ring-teal-500 hover:bg-teal-200"} type="button" onClick={props.stop}>
                    <div className={props.symbolSize + " hover:text-gray-600 text-gray-800 ri-stop-circle-line"}></div>
                    <div className={textSize + " hover:text-gray-600 text-gray-800"}>Lopeta</div>
                </button>
            );
            break;
        }
        case "stopped": {
            recorderButton = (
                <button className={props.size + props.ringSize + disabledRing + disabledText} type="button">
                    <div className={props.symbolSize + " ri-record-circle-fill"}></div>
                    <div className={textSize + " hover:text-gray-600 text-gray-800"}>Lopetettu</div>
                </button>);

            watchVideoButton = (
                <button className={props.size + props.ringSize + " ring-teal-500 hover:bg-teal-500"} type="button" onClick={() => props.setFileAvailable(true)}>
                    <div className={props.symbolSize + " text-teal-500 ri-play-fill hover:text-teal-400 text-teal-600"}></div>
                    <div className={textSize + " hover:text-gray-600 text-gray-800"}>Katso</div>
                </button>
            );
            break;
        }
        default: {
            break;
        }
    }

    return (
        <div className='flex gap-2 ml-20'>
            {recorderButton}
            {watchVideoButton}
        </div>
    );
}

export default Header;